module.exports = __webpack_public_path__ + "img/item-2.c438949.svg";